import _ from 'underscore';

import GroupSettingData from './GroupSettingData';

class GroupSetting {
  constructor(data: $TSFixMe) {
    Object.assign(this, _(data).pick('groupId', 'id', 'key'));

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'setting' does not exist on type 'GroupSe... Remove this comment to see the full error message
    this.setting = new GroupSettingData(data.setting);
  }

  get value() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'setting' does not exist on type 'GroupSe... Remove this comment to see the full error message
    return this.setting.value;
  }

  toJSON() {
    return {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
      ..._(this).pick('groupId', 'id', 'key'),
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'setting' does not exist on type 'GroupSe... Remove this comment to see the full error message
      setting: this.setting.toJSON(),
    };
  }
}

export default GroupSetting;
